<template>
  <div class="container mt-12 pb-10 ">
    <d-table class="pt-5"
             :loading="loading"
             :data="submissions"
             paginated
             backend-pagination
             backend-search
             :total="total"
             striped
             :per-page="pagination.pageSize"
             default-sort-direction="desc"
             backend-sorting
             :default-sort="[pagination.sortField, pagination.sortOrder]"
             :search.sync="filter"
             show-search
             @page-change="page => pagination.page = page"
             @sort="onSort"
    >
      <template #action-buttons>
        <h1 class="text-primary-500 mr-3">
          Project Registrations
        </h1>
      </template>
      <template #action-buttons-right>
        <div class="flex items-center">
          <d-field label="Filter By Status">
            <d-select v-model="statusFilter">
              <option :value="RequestStatus.Pending">
                {{ RequestStatus.Pending }}
              </option>
              <option :value="RequestStatus.Completed">
                {{ RequestStatus.Completed }}
              </option>
              <option :value="RequestStatus.Abandoned">
                {{ RequestStatus.Abandoned }}
              </option>
              <option :value="RequestStatus.ManuallyEntered">
                {{ RequestStatus.ManuallyEntered }}
              </option>
              <option :value="RequestStatus.InProgress">
                {{ RequestStatus.InProgress }}
              </option>
            </d-select>
          </d-field>
        </div>
      </template>

      <template slot-scope="props">
        <d-table-column field="projectInfo.name" :row="props.row" label="Project Name" sortable>
          <a :href="`/admin/forms/register-project/${props.row.id}`" class="font-bold">{{ props.row.projectInfo.name }}</a>
        </d-table-column>
        <d-table-column field="submitterName" :row="props.row" label="Submitter Name" sortable />
        <d-table-column field="createdAt" :row="props.row" label="Submitted Date" sortable centered>
          <div class="flex justify-center">
            {{ props.row.createdAt | formatShortDate }}
          </div>
        </d-table-column>
        <d-table-column field="status" :row="props.row" label="Status" sortable centered>
          <div class="flex justify-center">
            <d-chip :color="getStatusColor(props.row.status)">
              {{ props.row.status }}
            </d-chip>
          </div>
        </d-table-column>
      </template>
    </d-table>
  </div>
</template>

<script>
  import localforage from 'localforage';
  import { RequestStatus } from '@resources/scripts/models/enums';
  import { getPaged } from '@resources/scripts/services/api/projectRegistration.api';

  export default {
    parent: true,

    data() {
      return {
        RequestStatus, // enum
        loading: false,
        submissions: [],
        total: 0,
        statusFilter: '',
        filter: '',
        pagination: {
          page: 1,
          pageSize: 50,
          sortField: 'createdAt',
          sortOrder: 'desc',
        },
      };
    },

    watch: {
      pagination: {
        handler() {
          this.getSubmissionsPaged();
        },
        deep: true,
      },

      statusFilter(val) {
        localforage.setItem('RegisterProjectListingPage:StatusFilter', val);
        this.getSubmissionsPaged();
      },
      filter() {
        this.getSubmissionsPaged();
      },
    },

    mounted() {
      localforage.getItem('RegisterProjectListingPage:StatusFilter').then((value) => {
        this.statusFilter = value || RequestStatus.Pending;
        this.getSubmissionsPaged();
      });
    },

    methods: {
      async getSubmissionsPaged() {
        const {
          page, pageSize, sortField, sortOrder,
        } = this.pagination;
        this.loading = true;
        const { data } = await getPaged({
          page, pageSize, sortField, sortOrder, status: this.statusFilter, filter: this.filter,
        });
        this.submissions = data.resultItems;
        this.total = data.totalRecords;
        this.loading = false;
      },

      getStatusColor(status) {
        switch (status) {
          case RequestStatus.Abandoned:
            return 'gray-500';
          case RequestStatus.Completed:
            return 'green-500';
          default:
            return 'blue-500';
        }
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },
    },
  };
</script>